module.exports = __webpack_public_path__ + "resources/img/img_en_popup_marketing.f9c06b5927c2916709d662b22e9ecdd1.png";